export const DAYS_OF_WEEK = [
  {
    label: "Lunes",
    value: "L",
    id: '1'
  },
  {
    label: "Martes",
    value: "M",
    id: '2'
  },
  {
    label: "Miercoles",
    value: "X",
    id: '3'
  },
  {
    label: "Jueves",
    value: "J",
    id: '4'
  },
  {
    label: "Viernes",
    value: "V",
    id: '5'
  },
  {
    label: "Sabado",
    value: "S",
    id: '1'
  },
  {
    label: "Domingo",
    value: "D",
    id: '1'
  },
]